export default "__VITE_ASSET__qB6lrurU__"